import DashboardWrapper from "../../component/DashboardWrapper"
import PatientList from "../../component/dashboard_general/PatientList"
import LinkingRequestsList from "../../component/dashboard_general/LinkingRequestsList"
import OneTimePasswortInfo from "../../component/dashboard_general/OneTimePasswortInfo"
import ReportList from "../../component/dashboard_report/ReportList"

function ReportDashboardView() {
    return (
        <DashboardWrapper>
            <div className={"w-full flex flex-col space-y-4"}>
                <div className={"w-full flex space-x-4"}>
                    <div className={"flex-1 flex flex-col space-y-4"}>
                        <PatientList />
                        <LinkingRequestsList />
                        <OneTimePasswortInfo />
                    </div>
                    <div className={"flex-2"}>
                        <ReportList />
                    </div>
                </div>
            </div>
        </DashboardWrapper>
    )
}

export default ReportDashboardView
